import { objectWithoutProperties as _objectWithoutProperties } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { Section as Section$1 } from './Section.styles.js';

var _excluded = ["children"];
var Section = function Section(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Section$1, props, children);
};
var SectionComponent = Section;

export { SectionComponent as default };
//# sourceMappingURL=index.js.map
